import { createFileRoute } from '@tanstack/react-router';
import { ViewChoice } from '../../features/choices/view';
import { choicesReadGuard } from '@bmwe/ui';

export const Route = createFileRoute('/auswahlfelder/$choiceId')({
  component: ViewChoice,
  beforeLoad: choicesReadGuard,
});

export const ViewChoiceRoute = Route;
